import { Translation, QRType } from '../types';

export const pl: Translation = {
  nav: {
    generator: 'Generator',
    scanner: 'Skaner',
    mobile: 'Wypróbuj na telefonie',
    blog: 'Blog',
    langSelect: 'Wybierz język',
  },
  pageTitles: {
    generator: 'Darmowy generator kodów QR online',
    scanner: 'Skaner kodów QR online',
    textToQr: 'Tekst na kod QR',
    linkToQr: 'Link na kod QR',
  },
  pageMeta: {
    generator: {
      title:
        'Darmowy generator kodów QR — Twórz kody QR online (bez rejestracji, bez znaku wodnego, PNG/SVG/PDF) | YesQRCode',
      description:
        'Twórz kody QR online za darmo z YesQRCode. Generuj URL, tekst, Wi‑Fi, vCard i więcej. Pobierz PNG, SVG lub PDF w wysokiej jakości. Bez rejestracji, bez logowania, bez znaku wodnego — szybko, bezpiecznie i zawsze za darmo.',
      keywords: [
        'generator kodów qr',
        'darmowy generator qr',
        'tworzenie qr online',
        'kreator qr',
        'qr png',
        'qr svg',
        'qr pdf',
        'qr wifi generator',
        'qr vcard generator',
        'qr bez rejestracji',
      ],
    },
    scanner: {
      title:
        'Skaner kodów QR online — skanuj z obrazu lub kamery (bezpiecznie, bez rejestracji) | YesQRCode',
      description:
        'Skanuj kody QR i kody kreskowe online za darmo. Wgraj obraz lub użyj kamery. Całe przetwarzanie odbywa się lokalnie — bez wysyłania plików. Szybko, bezpiecznie i bez rejestracji.',
      keywords: [
        'skaner qr',
        'skanowanie qr online',
        'czytnik qr online',
        'qr z obrazu',
        'skaner kodów kreskowych online',
        'bezpieczny skaner qr',
        'skaner qr bez wysyłania',
        'darmowy skaner qr',
        'skaner qr w przeglądarce',
        'skaner qr bez rejestracji',
      ],
    },
    textToQr: {
      title: 'Tekst na QR | Zamień notatki na kody QR',
      description:
        'Zamień fragmenty tekstu, notatki lub wiadomości na kody QR do udostępniania. Dostosuj wygląd i eksportuj PNG, SVG lub PDF bez rejestracji.',
      keywords: ['tekst na qr', 'generator qr tekst', 'notatka qr', 'wiadomość qr', 'konwerter qr online', 'darmowy qr tekst'],
    },
    linkToQr: {
      title: 'Link na QR | Zamień URL na kod QR',
      description:
        'Wklej dowolny URL strony lub kampanii i od razu wygeneruj kod QR gotowy do druku lub użycia cyfrowego. Obsługuje kolory, logo i pobieranie w wysokiej rozdzielczości.',
      keywords: ['link na qr', 'generator qr url', 'qr dla strony', 'qr dla linku', 'utm qr', 'pobierz qr pdf'],
    },
  },
  hero: {
    title: 'Prywatne kody QR gotowe dla marki — zawsze za darmo.',
    subtitle: 'Szybkie, prywatne i elastyczne narzędzie QR do każdego workflow.',
    desc: 'Generuj i skanuj kody QR wysokiej jakości bez kont, znaków wodnych i wysyłania danych.',
    ctaPrimary: 'Wygeneruj kod QR',
    ctaSecondary: 'Wypróbuj na telefonie',
  },
  info: {
    helpTitle: 'Centrum pomocy',
    helpSubtitle: 'FAQ i wsparcie',
    contactTitle: 'Kontakt',
    contactSubtitle: 'Chętnie Cię wysłuchamy.',
    privacyTitle: 'Polityka prywatności',
    termsTitle: 'Warunki usługi',
  },
  contactForm: {
    name: 'Imię',
    email: 'E-mail',
    message: 'Wiadomość',
    send: 'Wyślij',
    orEmail: 'lub napisz bezpośrednio na',
    sending: 'Wysyłanie...',
    successTitle: 'Wysłano!',
    successMessage: 'Dziękujemy za wiadomość. Odezwiemy się wkrótce.',
    sendAnother: 'Wyślij kolejną wiadomość',
    errorMessage: 'Nie możemy teraz wysłać wiadomości. Napisz na support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Prywatne kody QR gotowe dla marki — zawsze za darmo.',
      subtitle: 'Szybkie, prywatne i elastyczne narzędzie QR do każdego workflow.',
      items: [
        { title: 'Prywatność przede wszystkim', desc: 'Generowanie lokalnie — bez wysyłania, śledzenia i zapisu danych.' },
        { title: 'Bogate funkcje', desc: 'URL, Wi‑Fi, vCard, kody kreskowe, logo, gradienty, ramki.' },
        { title: 'Wygodne na mobile', desc: 'UI zoptymalizowane pod telefony i dotyk.' },
        { title: 'Darmowe na zawsze', desc: 'Bez konta, bez znaków wodnych, bez limitów skanów.' },
      ],
    },
    featureSuite: {
      title: 'Kompletny, prywatny pakiet QR',
      subtitle: 'Wszystko, czego potrzebujesz do tworzenia czystych, markowych kodów QR wysokiej jakości — w jednym miejscu.',
      categories: [
        {
          title: 'Wszystkie typy kodów QR',
          body: 'URL, Tekst, Wi‑Fi, E-mail, Telefon, SMS, vCard, linki społecznościowe, YouTube, kody kreskowe. Statyczne kody bez wygaśnięcia.',
          items: [],
        },
        { title: 'Branding i design', body: 'Bezpieczne dla logo, gradienty, ramki, kształty, rogi i układy zoptymalizowane pod skan.', items: [] },
        { title: 'Eksport i jakość', body: 'Eksport PNG/SVG/PDF w wysokiej jakości z presetami do druku i digital.', items: [] },
        { title: 'Globalnie i użytecznie', body: 'Wiele języków, mobile-first, wygodne także offline.', items: [] },
      ],
    },
    trust: {
      title: 'Zaufane przez twórców, zespoły i marki',
      subtitle:
        'YesQRCode jest lekkie, przewidywalne i bezpieczne dla długich kampanii — bez kont, bez lock-in i bez ukrytych limitów.',
      items: ['Brak onboarding', 'Statyczne kody', 'Bezpieczne dla firm: brak chmury', 'Spójny branding'],
    },
    sectionContent: 'Treść',
    sectionColors: 'Kolory',
    sectionLogo: 'Logo',
    sectionFrame: 'Ramka',
    sectionDesign: 'Design',
    sectionCorrection: 'Korekcja błędów',
    labelUrl: 'URL strony',
    labelText: 'Zwykły tekst',
    labelSsid: 'Nazwa sieci (SSID)',
    labelPassword: 'Hasło',
    labelEncryption: 'Szyfrowanie',
    labelFgColor: 'Kolor kodu',
    labelBgColor: 'Kolor tła',
    labelFrameText: 'Tekst ramki',
    labelFrameColor: 'Kolor ramki',
    placeholder: 'Wpisz treść tutaj...',
    placeholders: {
      url: 'https://example.com',
      text: 'Wpisz tekst',
      email: 'you@email.com',
      subject: 'Temat',
      message: 'Twoja wiadomość...',
      phone: '+48 600 000 000',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: 'Pobierz PNG',
    downloadSvg: 'Pobierz SVG',
    generateButton: 'Generuj kod QR',
    copy: 'Kopiuj SVG',
    uploadLogo: 'Wgraj obraz',
    preview: 'Podgląd',
    lowQuality: 'Niska jakość',
    highQuality: 'Wysoka jakość',
    foreverFree: 'Darmowe na zawsze • Bez rejestracji • Do użytku komercyjnego',
    barcodeWarning: 'Zaawansowane opcje (ramki i logo) nie są dostępne dla kodów kreskowych.',
    barcodeColors: 'Kolory nadal możesz dostosować poniżej.',
    frameStyles: {
      none: 'Brak',
      simple: 'Prosta',
      balloon: 'Dymek',
      box: 'Box',
      badge: 'Odznaka',
      polaroid: 'Polaroid',
      phone: 'Telefon',
      header: 'Nagłówek',
      corner: 'Róg',
    },
    vCard: {
      firstName: 'Imię',
      lastName: 'Nazwisko',
      mobile: 'Komórka',
      phone: 'Telefon',
      fax: 'Faks',
      email: 'E-mail',
      company: 'Firma',
      job: 'Stanowisko',
      street: 'Ulica',
      city: 'Miasto',
      zip: 'Kod pocztowy',
      state: 'Województwo',
      country: 'Kraj',
      website: 'Strona WWW',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Tekst',
      [QRType.EMAIL]: 'E-mail',
      [QRType.PHONE]: 'Telefon',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi‑Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Kod kreskowy',
    },
    guide: { title: 'Jak utworzyć własny kod QR?', steps: [] },
    gettingStarted: {
      title: 'Jak używać',
      steps: [
        { title: 'Ustaw treść', text: 'Wybierz typ (URL, tekst, e-mail...). Uzupełnij pola i upewnij się, że są poprawne.' },
        { title: 'Dostosuj wygląd', text: 'Zmień kolory i kształty, dodaj logo z galerii lub wgraj własne.' },
        { title: 'Wygeneruj kod', text: 'Ustaw rozdzielczość suwakiem, pobierz i sprawdź kod, skanując podgląd.' },
        { title: 'Pobierz plik', text: 'Pobierz PNG/SVG/PDF. SVG to format wektorowy; logo i design działają dla PNG i SVG.' },
      ],
    },
    about: {
      title: 'Darmowy, prywatny pakiet QR',
      subtitle: 'Generuj i skanuj kody QR bez kont, znaków wodnych i wysyłania danych.',
      features: [
        'Popularne typy: URL, tekst, Wi‑Fi, vCard, SMS i kody kreskowe',
        'Bezpieczne dla logo (do 30% korekcji błędów)',
        'Kształty, gradienty, kolory i ramki',
        'Statyczne kody bez wygaśnięcia',
        'Wielojęzyczny interfejs',
      ],
      content: [
        { title: 'Bezpieczne dla logo', body: 'Dodawaj logo bez obaw o skanowanie dzięki wysokiej korekcji błędów.' },
        { title: 'Kształty i ramki', body: 'Zmieniaj rogi, gradienty i ramki, zachowując czytelność kodu.' },
        { title: 'Wiele typów treści', body: 'Generuj URL, tekst, Wi‑Fi, vCard, SMS i kody kreskowe w jednym miejscu.' },
        { title: 'Statyczne na lata', body: 'Kody statyczne bez wygaśnięcia i limitów skanów.' },
      ],
    },
    faq: {
      title: 'Najczęstsze pytania',
      items: [
        { q: 'Co to jest kod QR?', a: 'QR (Quick Response) to rodzaj kodu kreskowego wynaleziony przez Denso Wave w 1994 roku.' },
        { q: 'Czy mogę używać kodów komercyjnie?', a: 'Tak, wszystkie kody wygenerowane tutaj są darmowe i możesz je wykorzystywać dowolnie.' },
        { q: 'Czy kody QR wygasają?', a: 'Nie. To kody statyczne, więc działają zawsze (nie można edytować treści po utworzeniu).' },
        { q: 'Czy jest limit skanów?', a: 'Nie ma limitu — skanuj ile chcesz.' },
        { q: 'Czy zapisujecie moje dane?', a: 'Nie zapisujemy ani nie wykorzystujemy danych. Dla wydajności możemy cache’ować pliki obrazów do 24h.' },
        { q: 'Dlaczego vCard nie pokazuje poprawnych pól?', a: 'Nie każdy skaner przestrzega standardu vCard. Spróbuj innej aplikacji.' },
        { q: 'Kod nie działa — co robić?', a: 'Sprawdź dane, usuń logo, zmniejsz ilość danych i zadbaj o kontrast.' },
        { q: 'Czy działa we wszystkich przeglądarkach?', a: 'Wymaga nowoczesnej przeglądarki HTML5; oficjalnie wspiera Chrome, Firefox, Safari, Edge i Internet Explorer 11.' },
      ],
    },
  },
  scanner: {
    title: 'Skanuj kody QR i kreskowe',
    subtitle: 'Użyj kamery, wgraj obraz lub wklej, aby natychmiast odczytać QR i kody kreskowe.',
    cameraPermission: 'Odmówiono dostępu do kamery. Włącz uprawnienia w ustawieniach przeglądarki.',
    result: 'Wynik',
    copy: 'Kopiuj',
    copied: 'Skopiowano',
    open: 'Otwórz link',
    delete: 'Usuń',
    scanAgain: 'Skanuj ponownie',
    privacy: 'Przetwarzanie odbywa się lokalnie w przeglądarce. Pliki nie opuszczają Twojego urządzenia.',
    upload: 'Wgraj obraz',
    paste: 'Wklej (Ctrl+V)',
    drop: 'Upuść obraz tutaj',
    retry: 'Spróbuj ponownie',
    errorAccessDenied: 'Odmowa dostępu do kamery',
    errorCamera: 'Zezwól na dostęp do kamery w ustawieniach przeglądarki.',
    initializing: 'Inicjalizacja kamery...',
    cameraActive: 'Kamera aktywna',
    scannedItems: 'Zeskanowane',
    recentScans: 'Ostatnie (lokalnie)',
    clickToUpload: 'Kliknij, aby wgrać',
    newBadge: 'NOWE',
    tabCameraMobile: 'Kamera',
    tabCameraDesktop: 'Skanuj kamerą',
    emptyState: { title: 'Brak skanów', desc: 'Wgraj obraz lub użyj zakładki kamery, aby zacząć.' },
    highlights: {
      title: 'Szybkie i prywatne skanowanie',
      items: [
        { title: 'Odczyt na urządzeniu', desc: 'Bez wysyłania — bezpieczne dla wrażliwych danych.' },
        { title: 'Wiele formatów', desc: 'QR plus UPC/EAN, Code 128, ITF i inne.' },
        { title: 'Szybkie akcje', desc: 'Upuść plik, wklej zrzut ekranu lub przełącz na live scan.' },
        { title: 'Świetne na mobile', desc: 'UI i kamera zoptymalizowane pod małe ekrany.' },
      ],
    },
    intro: { title: 'Skaner QR i kodów kreskowych online', body: 'Odczytuj QR, UPC, EAN i więcej bez instalowania aplikacji.' },
    howTo: {
      title: 'Jak skanować?',
      methods: [
        { title: 'Metoda 1: Wgraj', steps: ['Kliknij Wgraj obraz', 'Wybierz QR/kod kreskowy', 'Zobacz wynik'] },
        { title: 'Metoda 2: Kamera', steps: ['Otwórz zakładkę Kamera', 'Udziel uprawnień', 'Nakieruj na kod'] },
      ],
    },
    features: {
      title: 'Dlaczego ten skaner?',
      items: [
        { title: 'Historia lokalna', desc: 'Ostatnie skany są zapisywane tylko na Twoim urządzeniu.' },
        { title: 'Odczyt obrazów offline', desc: 'Wgrywanie/wklejanie działa offline; kamera wymaga uprawnień.' },
        { title: 'Szybkie działania', desc: 'Kopiuj, otwieraj lub usuwaj wyniki jednym kliknięciem.' },
      ],
    },
    useCases: {
      title: 'Popularne zastosowania',
      items: [
        { title: 'Handel i zakupy', desc: 'Sprawdzaj URL-e produktów, kupony i instrukcje.' },
        { title: 'Zespoły magazynowe', desc: 'Weryfikuj kody kreskowe i aktualizuj stany.' },
        { title: 'Na co dzień', desc: 'Szybko otwieraj menu, Wi‑Fi lub kontakty.' },
      ],
    },
    faq: {
      title: 'FAQ skanera',
      items: [
        { q: 'Czy mogę skanować kody kreskowe?', a: 'Tak — obsługuje QR oraz Code 128, UPC, EAN, ITF i inne.' },
        { q: 'Czy zapisujecie skany?', a: 'Nie — wszystko pozostaje w przeglądarce i na urządzeniu.' },
        { q: 'Czy mogę wkleić zrzut ekranu?', a: 'Tak — użyj Ctrl+V (Cmd+V), aby wkleić z schowka.' },
        { q: 'Czy działa offline?', a: 'Wgrywanie obrazów działa offline; skanowanie kamerą wymaga uprawnień i wspieranego browsera.' },
      ],
    },
  },
  blog: {
    title: 'Poradniki i aktualności',
    subtitle: 'Najlepsze praktyki, pomysły marketingowe i aktualizacje produktu o QR.',
    readMore: 'Czytaj dalej',
    back: 'Wróć do bloga',
    notFound: 'Nie znaleziono wpisu',
  },
  common: {
    footer: 'Mocny pakiet do tworzenia kodów QR dla marketerów, projektantów i zespołów.',
    privacy: 'Prywatność',
    terms: 'Warunki',
    contact: 'Kontakt',
    scanToOpen: 'Zeskanuj, aby otworzyć na telefonie',
    help: 'Pomoc',
    free: 'Darmowe',
    product: 'Produkt',
    resources: 'Zasoby',
    company: 'Firma',
    api: 'API (wkrótce)',
    systemStatus: 'Systemy działają',
    footerDesc: 'Zaawansowany generator i skaner QR. Szybki, prywatny i darmowy na zawsze do użytku prywatnego i komercyjnego.',
  },
};

